import get from 'lodash.get';

import { LogService } from './log-service';
import { InsuranceProviders } from '../enums/insurance-providers';
import { Carriers } from '../constants/carriers';

const deriveTotalPrice = (labelCost, insuranceCost) => {
  if (labelCost.code !== insuranceCost?.code) {
    LogService.logInfo('Deriving total price with potentially two different or unknown currencies', { labelCost, insuranceCost });
  }
  // This makes the (temporarily correct) incorrect assumption that insurance and label will always be the same currency
  return {
    code: labelCost.code,
    value: labelCost.value + insuranceCost.value,
  };
};

class ShipmentHelperServiceClass {
  anyNotificationErrored(shipmentStatus) {
    return !!Object.keys(shipmentStatus)
      .filter((key) => key.includes('Notification'))
      .map((notificationType) => get(shipmentStatus, `${notificationType}.errorMessage`, null))
      .filter((error) => error !== null).length;
  }

  getTotalCost(fulfillment = {}, rateSummaryTotalCost) {
    const { totalCost, labelCost, insuranceCost, insuranceProviderId, carrierId } = fulfillment;
    const hasNonZeroInsuranceCostValue = insuranceCost && insuranceCost.value;
    const hasNonZeroLabelCostValue = labelCost && labelCost.value;
    const insuranceProvidedByCarrier = InsuranceProviders.Carrier.insuranceProviderId === insuranceProviderId;

    // Once the backend begins providing totalCost as part of the fulfillment object, this function will use that value instead of hacking together our own. At this point we should determine whether any of the code in this file is necesssary
    if (totalCost) {
      LogService.logInfo('Using total cost from fulfillment plan... remove code to rely on deriving it', {
        totalCost,
        labelCost,
        insuranceCost,
      });
      return totalCost;
    }

    // UPS Standalone calculated cost with Carrier insurance is different from label cost. Here we will add
    // insurance and label cost and compare to the FP Rate Summary cost for confirmation.
    if (Carriers.UPS.carrierId === carrierId && hasNonZeroLabelCostValue) {
      const UPSTotalCost = deriveTotalPrice(labelCost, insuranceCost);
      if (
        fulfillment.fulfillmentId &&
        rateSummaryTotalCost &&
        (UPSTotalCost.code !== rateSummaryTotalCost?.code || UPSTotalCost.value !== rateSummaryTotalCost?.value)
      ) {
        LogService.logInfo(
          'UPS Fulfillment Calculated Total Cost (label + insurance) different from FulfillmentPlan Rate Summary Total Cost',
          { UPSTotalCost, rateSummaryTotalCost },
        );
      }
      return UPSTotalCost;
    }

    if (!hasNonZeroInsuranceCostValue || insuranceProvidedByCarrier) {
      return labelCost;
    }

    if (hasNonZeroLabelCostValue) {
      return deriveTotalPrice(labelCost, insuranceCost);
    }
  }
}

export const ShipmentHelperService = new ShipmentHelperServiceClass();
